// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + (chunkId === 347 ? "secondary" : chunkId) + "." + {"347":"f71c685d5806456b5348","574":"663034d5a44e0e8a7c91"}[chunkId] + ".js";
};